import { render, staticRenderFns } from "./riskRecord.vue?vue&type=template&id=01fdbe67&scoped=true"
import script from "./riskRecord.vue?vue&type=script&lang=ts"
export * from "./riskRecord.vue?vue&type=script&lang=ts"
import style0 from "./riskRecord.vue?vue&type=style&index=0&id=01fdbe67&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fdbe67",
  null
  
)

export default component.exports